/**
 * SafeGuard is an account-wide switch (Settings → SafeGuard). Agents inherit
 * it — they never turn it on or off themselves.
 */

export function globalSafeGuardCopy({ enabled, followUp = false } = {}) {
  const on = enabled === true;
  const label = on ? "Global SafeGuard is Active" : "Global SafeGuard is Off";
  const detail = followUp
    ? "Inherited from your account. Follow-up emails are never reviewed."
    : on
      ? "Inherited from your account. Reviews introduction emails when they are sent — not configured on this agent."
      : "Inherited from your account. Introduction emails send without review. Turn it on in Settings → SafeGuard.";
  return {
    label,
    detail,
    title: detail,
    tone: on ? "emerald" : "slate",
    icon: on ? "fa fa-shield-alt" : "fa fa-shield-halved",
    enabled: on,
  };
}

export function globalSafeGuardChip(opts) {
  const copy = globalSafeGuardCopy(opts);
  return {
    k: copy.enabled ? "sg-global-on" : "sg-global-off",
    icon: copy.icon,
    label: copy.label,
    tone: copy.tone,
    title: copy.title,
  };
}
